import { createStorageWrapper } from './storage';

const moduleWindow = (typeof window !== 'undefined' && window) || null;

/**
 * クライアント用 : session storage用のラッパーモジュール
 */
interface ISessionStorage {
  get: <T>(key: string, defaultValue?: T) => T | undefined;
  set: <T>(key: string, value: T) => void;
  remove: (key: string) => void;
}

export const sessionStorage: ISessionStorage = createStorageWrapper(() => moduleWindow?.sessionStorage);
